import { Component } from '@angular/core';

@Component({
  selector: 'medrecord-ui-feature',
  templateUrl: './feature.component.html',
})
export class WillBeSoonFeatureComponent {}
